<ion-header class=ion-no-border>
    <ion-toolbar mode="ios">
        <ion-title>{{'MergeDuplicate' | translation}}</ion-title>
        <ion-buttons slot="end">
            <ion-button fill="clear" (click)="dismiss()">
                <ion-icon name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <ion-item class="ion-no-padding" style="--inner-padding-end: 0px;">
        <ion-label position="stacked"></ion-label>
        <ion-select label="{{'SelectSeeker' | translation}}" label-placement="stacked" [(ngModel)]="merge_to_seeker" placeholder="{{'SelectOne' | translation}}">
            <ion-select-option *ngFor="let item of seekers" [value]="item.uuid">{{item.first_name + ' ' + item.last_name}}</ion-select-option>
        </ion-select>
    </ion-item>
    <ion-button class="pty-save-seeker-button" expand="full" shape="round" (click)="mergeDuplicate()" style="margin-top: 40px;">
        {{'Merge' | translation}}
    </ion-button>
</ion-content>
